import React from "react";
import { Card, Box, Typography, Chip, Divider } from "@mui/material";
import { blue, indigo, green, amber, red, grey } from "@mui/material/colors";
import { FolderKanban } from "lucide-react";

// Helper to map tailwind color strings to MUI colors
const getColor = (colorClass) => {
  if (colorClass.includes("indigo")) return indigo[600];
  if (colorClass.includes("green")) return green[600];
  if (colorClass.includes("amber")) return amber[600];
  if (colorClass.includes("rose")) return red[600];
  if (colorClass.includes("blue")) return blue[600];
  return grey[600];
};

const ProjectCard = ({ project, taskCount, onClick }) => {
  const mainColor = getColor(project.color);

  return (
    <Card
      onClick={onClick}
      sx={{
        p: 3,
        borderRadius: 3,
        cursor: "pointer",
        transition: "all 0.2s",
        "&:hover": {
          boxShadow: 6,
          borderColor: "primary.main",
        },
        border: "1px solid",
        borderColor: "divider",
      }}
      elevation={0}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <Box
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: mainColor,
            color: "white",
            opacity: 0.9, // Slight transparency
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FolderKanban size={24} color="white" />
        </Box>
        <Chip
          label={project.status}
          size="small"
          color={project.status === "Active" ? "success" : "default"}
          variant="outlined"
          sx={{
            fontWeight: "medium",
            borderColor: project.status === "Active" ? green[200] : grey[300],
            bgcolor: project.status === "Active" ? green[50] : grey[100],
            color: project.status === "Active" ? green[800] : grey[700],
          }}
        />
      </Box>
      <Typography
        variant="h6"
        fontWeight="bold"
        color="text.primary"
        gutterBottom
        sx={{
          "&:hover": { color: "primary.main" },
          transition: "color 0.2s",
        }}
      >
        {project.name}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        mb={2}
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          height: 40,
        }}
      >
        {project.description}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="caption"
          sx={{
            fontFamily: "monospace",
            bgcolor: "action.hover",
            px: 1,
            py: 0.5,
            borderRadius: 1,
            color: "text.secondary",
          }}
        >
          {project.key}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {taskCount} Tasks
        </Typography>
      </Box>
    </Card>
  );
};

export default ProjectCard;
